import { render, staticRenderFns } from "./CopyUrl.vue?vue&type=template&id=98728782"
import script from "./CopyUrl.vue?vue&type=script&lang=js"
export * from "./CopyUrl.vue?vue&type=script&lang=js"
import style0 from "./CopyUrl.vue?vue&type=style&index=0&id=98728782&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports